import axios from 'lib/axios'

export interface InventoryInvoice {
  id: number
  invoice_number: string
  invoice_date: string
  amount: string
}

export interface NewInventoryInvoice {
  invoice_number: string
  invoice_date: string
  amount: string
}

interface InventoryInvoicesResponse {
  status: 'OK'
  data: InventoryInvoice[]
}

export const getInventoryInvoices = async (inventoryId: number): Promise<InventoryInvoice[]> => {
  const response = await axios.get<InventoryInvoicesResponse>(`/subscription_company/${inventoryId}/invoices`)
  return response.data.data
}

export const createInventoryInvoice = async (
  inventoryId: number,
  invoice: NewInventoryInvoice,
): Promise<InventoryInvoice> => {
  const response = await axios.post<{ status: 'OK'; data: InventoryInvoice }>(
    `/subscription_company/${inventoryId}/invoices`,
    invoice,
  )
  return response.data.data
}

export const updateInventoryInvoice = async (
  inventoryId: number,
  invoiceId: number,
  invoice: NewInventoryInvoice,
): Promise<InventoryInvoice> => {
  const response = await axios.put<{ status: 'OK'; data: InventoryInvoice }>(
    `/subscription_company/${inventoryId}/invoices/${invoiceId}`,
    invoice,
  )
  return response.data.data
}

export const deleteInventoryInvoice = async (inventoryId: number, invoiceId: number): Promise<void> => {
  await axios.delete(`/subscription_company/${inventoryId}/invoices/${invoiceId}`)
}
